/**
 * GOOGLE ADMOB — inert stub for web and portal builds.
 *
 * `vite --mode capacitor` (npm run build:app) resolves this module to `admob-bridge-capacitor.js`
 * instead (see `capacitorNativeAppPlugin` in vite.config.js), so portal bundles never contain the
 * AdMob plugin or ad unit ids.
 */

function resolveEmpty() {
  return Promise.resolve();
}

export const AdMobBridge = {
  /** Consent form (UMP) and Mobile Ads SDK start. */
  ensureInitialized: resolveEmpty,
  isEnabled: function () {
    return false;
  },
  canOfferRewardedAds: function () {
    return false;
  },
  /** Web builds keep their own analytics rules. */
  allowsAnalytics: function () {
    return true;
  },
  /** Whether Google requires a way back to the consent choices (EEA). */
  privacyOptionsRequired: function () {
    return false;
  },
  /** @returns {Promise<void>} */
  showPrivacyOptionsForm: resolveEmpty,
  /**
   * @param {{ game?: object }} [_options]
   * @returns {Promise<void>}
   */
  commercialBreak: function (_options) {
    return Promise.resolve();
  },
  /**
   * @param {{ onError?: (err: unknown) => void }} [options]
   * @returns {Promise<{ granted: boolean, cancelled: boolean }>}
   */
  requestRewardedAd: function (options) {
    if (options && typeof options.onError === "function") {
      options.onError(new Error("rewarded ad unavailable"));
    }
    return Promise.resolve({ granted: false, cancelled: false });
  },
};
